import { Component, Element, State, Prop, h } from '@stencil/core';

import { store } from "../../redux/LoyaltyProgramRedux";
import { Unsubscribe } from 'redux';
import { i18n } from '@oebb-web-team/oebb-web-components';
import { CrmData } from '../../dto/CrmData';
import { sleep } from '../../redux/utilities';
import { loyaltyProgramI18n } from '../loyalty-program-i18n/loyalty-program.i18n';
import { getCurrentLanguage } from '../../utils/utils';

@Component({
	tag: 'loyalty-program-username',
	styleUrl: 'loyalty-program-username.scss',
	shadow: false,
})
export class LoyaltyProgramUsername {
	private unsubscribe: Unsubscribe | null = null;
	private defaultContent: string | null;

	@Element() el: HTMLElement;

	@State() givenName = '';
	@State() fullName = '';
	@State() displayName = '';
	@State() isLoading: boolean = true;

	@Prop() welcomeText: string;
	@Prop() greeting: boolean;
	@Prop() fullname: boolean = false;

	connectedCallback(){
		this.defaultContent = this.el.children[0]?.textContent;
		i18n.add(loyaltyProgramI18n);
		i18n.setLang(getCurrentLanguage());
	}

	componentWillLoad() {
		this.unsubscribe = store.subscribe(async() => {
			const state = store.getState()
			const crmData: CrmData = state.crmData;

			if(state.user === undefined || state.user === null){
				this.displayName = '';
			} else {
				this.givenName = state.user.givenName;
				this.fullName = this.givenName && state.user.lastName
					? this.givenName + ' ' + state.user.lastName
					: null;
			}

			if (!this.hasName() && crmData) {
				this.givenName = crmData.firstName;
				this.fullName = crmData.firstName && crmData.lastName
				? crmData.firstName + ' ' + crmData.lastName
				: null;
				this.setDisplayName()
			}

			if(!crmData || state.user === null){
				this.displayName = '';
			}
		});

		(async () => {
			await sleep(250);
		})();
	}

	componentWillRender() {
		this.removeDefaultContent();
	}

	disconnectedCallback() {
		this.unsubscribe?.();
	}

	removeDefaultContent() {
		if (!this.hasName()) return;

		if (this.el.children.length > 1) {
			this.el.children[0].remove();
		}
	}

	setDisplayName(): void {
		this.displayName = this.fullname ? this.fullName : this.givenName;
	}

	hasName(): boolean {
		return !(this.displayName === undefined || this.displayName === null || this.displayName === '');
	}

	hasWelcomeText(): boolean {
		return !(this.welcomeText === undefined || this.welcomeText === null || this.welcomeText === '');
	}

	getGreeting(): string {
		const currentTime = new Date();

		switch (currentTime.getHours()) {
			case 0:
			case 1:
			case 2:
			case 3:
			case 22:
			case 23:
				return i18n.get('lp.greetings.good_night');
			case 4:
			case 5:
			case 6:
			case 7:
			case 8:
				return i18n.get('lp.greetings.good_morning');
			case 9:
			case 10:
			case 11:
			case 12:
			case 13:
				return i18n.get('lp.greetings.good_day');
			case 14:
			case 15:
			case 16:
				return i18n.get('lp.greetings.good_afternoon');
			case 17:
			case 18:
			case 19:
			case 20:
			case 21:
				return i18n.get('lp.greetings.good_evening');
			default:
				throw new Error('There\'s something wrong with your computer\'s clock.');
		}
	}

	render() {
		if (!this.hasName()) {
			if (this.greeting) {
				return (
					<span>{this.getGreeting()}</span>
				);
			} else if(this.el.children.length < 1) {
				return <span>{this.defaultContent}</span>;
			}
		}
		return (
			<span>
				{ this.greeting
					? this.getGreeting() + ', ' + this.displayName
					: this.hasWelcomeText()
						? this.welcomeText.includes('{}')
							? this.welcomeText.replace('{}', this.displayName)
							: this.welcomeText + ' ' + this.displayName
						: this.displayName
				}
			</span>
		);
	}
};
